import { useContext } from "react";

import { AppConfigContext } from "../../../core/configuration/Configuration";
import { useAuthorizedFetch } from "../../../core/data-access/useAuthorizedFetch";
import { ExecutionType } from "../../types/ExecutionType";
import { GetExecutionsResponse } from "./GetExecutionsResponse";

export const useMonitoringApi = () => {
    const appConfigContext = useContext(AppConfigContext);
    const baseUrl = `${appConfigContext.monitoringConfig.apiUrl}`;
    const executionsBaseUrl = `${baseUrl}/executions`;

    const { httpPost } = useAuthorizedFetch();

    const getExecutions = async (type: ExecutionType, ids: string[]): Promise<GetExecutionsResponse> => {
        return httpPost(`${executionsBaseUrl}/get-executions`, { type, ids });
    };

    return {
        getExecutions
    };
};
